import * as React from 'react';
const SvgFavorite = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M9.992 15.946q-.247 0-.475-.086a1.4 1.4 0 0 1-.434-.27l-.989-.9q-2.279-2.022-3.978-3.908t-1.7-3.99q0-1.65 1.131-2.762t2.807-1.113q.97 0 1.92.444T10 4.87q.818-1.065 1.752-1.51a4.36 4.36 0 0 1 1.887-.444q1.677 0 2.81 1.113t1.134 2.762q0 2.127-1.74 4.026a55 55 0 0 1-3.938 3.863l-.997.91a1.4 1.4 0 0 1-.437.27 1.4 1.4 0 0 1-.48.085m-.508-9.914q-.572-1.03-1.383-1.53A3.26 3.26 0 0 0 6.355 4q-1.223 0-2.039.792T3.5 6.8q0 .975.626 2.017.625 1.042 1.57 2.093.947 1.05 2.055 2.04 1.108.991 2.08 1.856a.25.25 0 0 0 .169.065q.096 0 .168-.065.973-.865 2.081-1.855t2.054-2.041a13.7 13.7 0 0 0 1.571-2.093Q16.5 7.775 16.5 6.8q0-1.216-.816-2.008Q14.87 4 13.646 4q-.937 0-1.758.501-.821.5-1.393 1.531a.42.42 0 0 1-.204.23.65.65 0 0 1-.292.07.7.7 0 0 1-.301-.07.4.4 0 0 1-.214-.23'
            />
        </g>
    </svg>
);
export default SvgFavorite;
